import Icon from '@material-ui/icons/Business';
import List from './VendorList';
import Create from './VendorCreate';
import Edit from './VendorEdit';

export default {
    list: List,
    create: Create,
    edit: Edit,
    icon: Icon,
};
